import OrganizationsTable from './OrganizationsTable'
export default OrganizationsTable


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/Hotels24Tab/MappingTabs/OrganizationTab/OrganizationTable/index.js